// web_components/wcNutshell/wcNutshell_Renderer.ts

/**
 * Generates the HTML for the wc-nutshell component.
 * Handles CSS, variables, etc.
 *
 * @param {object} dataAttributes - Data attributes for styling and contextual information.
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(dataAttributes: any, instanceId: string): string {
	// Initialize styleTag to an empty string
	let styleTag = '';

	// Check if 'css' exists in dataAttributes and is an object
	if (dataAttributes.css && typeof dataAttributes.css === 'object') {
		styleTag = `<style>`;
		for (const [selector, styles] of Object.entries(dataAttributes.css)) {
			styleTag += `${selector} { ${styles} }`;
		}
		styleTag += `</style>`;
	}

	// Access variables and assign to 'variables', defaulting to an empty object if undefined
	const variables = dataAttributes.variables || {};

	return `
        ${styleTag}
        
        <div id="${instanceId}" class="wc-nutshell">
			<div class="wc-nutshell__content">
				${
					variables.nutshellHeading
						? `
					<span>${variables.nutshellHeading}</span>
				`
						: ''
				}
				${
					variables.nutshellCopy
						? `
					<p>${variables.nutshellCopy}</p>
				`
						: ''
				}
				<ul>
					${variables.nutshellListItem1 ? `<li>${variables.nutshellListItem1}</li>` : ''}
					${variables.nutshellListItem2 ? `<li>${variables.nutshellListItem2}</li>` : ''}
					${variables.nutshellListItem3 ? `<li>${variables.nutshellListItem3}</li>` : ''}
					${variables.nutshellListItem4 ? `<li>${variables.nutshellListItem4}</li>` : ''}
				</ul>
				${
					variables.nutshellEmphasisedCopy
						? `
								<p class="wc-nutshell__emphasised-copy">${variables.nutshellEmphasisedCopy}</p>
							`
						: ''
				}
			</div>
        </div>
    `;
}
